import { io } from "socket.io-client";
import { probeIapSession } from "@/utils/iapSession";
import { isProductionBuild } from "@/utils/deployEnvironment";

// Fails closed (see utils/deployEnvironment.js): an unset or unrecognised
// VUE_APP_DEPLOY_ENV resolves to production. Treating "unknown" as dev used to
// mean a prod bundle that lost the variable would silently pick the dev socket
// path, send credentials cross-origin, and skip the VUE_APP_SOCKET_ORIGIN
// assertion below - the exact check written to catch that case.
const isProduction = isProductionBuild();
const socketOrigin = String(process.env.VUE_APP_SOCKET_ORIGIN || "").trim();

if (isProduction && !socketOrigin) {
  throw new Error("VUE_APP_SOCKET_ORIGIN is required in production");
}

const socketOptions = {
  path: isProduction ? "/api/socket.io" : "/socket/api/socket.io",
  transports: ["websocket"],
  autoConnect: false,
  reconnection: true,
  reconnectionAttempts: Infinity,
  reconnectionDelay: 1000,
  reconnectionDelayMax: 5000,
  timeout: 20000,
  withCredentials: !isProduction,
};

const socket = isProduction
  ? io(socketOrigin, socketOptions)
  : io(socketOptions);

if (!isProduction) {
  socket.on("connect_error", async () => {
    if (await probeIapSession()) {
      socket.io.opts.reconnection = false;
      socket.disconnect();
    }
  });
}

export default socket;
